import { render, staticRenderFns } from "./AfterLogin.vue?vue&type=template&id=23650c52&"
import script from "./AfterLogin.vue?vue&type=script&lang=js&"
export * from "./AfterLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AfterLogin.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VTimeline } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VTimeline,
  VTimelineItem,
})
